/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'
import { FAILURE, SUCCESS } from '../constants/Constants'

export const getCall = (url: string, callback: any) => {
  axios.get(url)
    .then(function (response:any) {
      // handle success
      callback(response.data, SUCCESS)
    })
    .catch(function (error:any) {
      // handle error
      callback(error, FAILURE)
    })
    .then(function () {
      // always executed
    })
}

export const postCall = (url: string, callback: any, body:any) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    }
  }
  axios.post(url, body)
    .then(function (response:any) {
      // handle success
      callback(response.data, SUCCESS, config)
    })
    .catch(function (error:any) {
      console.log('ERROR = ' + error)
      // handle error
      callback(error, FAILURE)
    })
    .then(function () {
      // always executed
    })
}

export const getHostUrl = () => {
  return `https://${window.location.hostname}/`
}
